// REDUX ACTION TYPES
export const CHANGE_USERINFO = 'CHANGE_USERINFO'